import { useMemo } from 'react';
import dayjs from 'dayjs';
import type { ILaunchpad } from '@tacans/shared-marketplace-layer';
import { useCountdown } from 'src/hooks/useCountdown';

export const useLaunchpadStatus = ({ launchpad } : { launchpad: ILaunchpad }) => {
    const countdown = useCountdown(launchpad.mintDate);

    return useMemo(() => {
        const mintDate = dayjs(launchpad.mintDate);
        const isExpired = dayjs().isAfter(mintDate);
        const isActive = isExpired && launchpad.isEnabled;
        const isPlanned = !isExpired && launchpad.isEnabled;
        const { days, hours, minutes, seconds } = countdown;
        const availableNftsCount = +(launchpad.totalItems || 0) - +(launchpad.mintedItems || 0);
        const isNotActive = (!isActive && !isPlanned) || (isExpired && !availableNftsCount);

        let label = 'Not Active';
        if (isActive && availableNftsCount) {
            label = 'Active';
        }
        if (isPlanned) {
            label = +days === 0
                ? `${hours.toString().padStart(2, '0')}h : ${minutes.toString().padStart(2, '0')}m : ${seconds.toString().padStart(2, '0')}s`
                : mintDate.format('MMM D, YYYY');
        }

        return {
            isExpired,
            isActive,
            isNotActive,
            isPlanned,
            label,
        };
    }, [launchpad, countdown]);
};
